import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { IBase } from '../models';
import { StorageService } from '../services';
import {
  ITripsFilters,
  DEFAULT_TRIP_STATUS,
  parseTripsFiltersFromStorage,
  serializeTripsFilters,
} from '../filters';

/**
 * Hydrates the URL from localStorage *before* the resolver runs, so the data
 * fetch happens only once per sidebar entry. See {@link bookingsHydrationGuard}.
 */
export const tripsHydrationGuard: CanActivateFn = async (route, state) => {
  if (route.queryParamMap.keys.length > 0) return true;

  const storage = inject(StorageService);
  const router = inject(Router);

  const storedFilters = parseTripsFiltersFromStorage(await storage.getTripsFilters());
  // Towns live in the legacy "area" storage; merge so the URL covers all trip filters.
  const areaJson = await storage.getArea();
  const selectedTowns: IBase[] = areaJson ? JSON.parse(areaJson) : [];

  const filters: ITripsFilters = storedFilters
    ? { ...storedFilters, selectedTowns }
    : {
        selectedClients: [], selectedOperators: [], selectedTowns,
        selectedServices: [], selectedRoutes: [], selectedTypes: [],
        selectedStatus: DEFAULT_TRIP_STATUS, selectedAvailabilityId: null,
      };
  const serialized = serializeTripsFilters(filters);
  const queryParams: { [key: string]: string | number } = {};
  for (const [k, v] of Object.entries(serialized)) {
    if (v != null && v !== '') queryParams[k] = v as string;
  }
  if (Object.keys(queryParams).length === 0) return true;

  const path = state.url.split('?')[0];
  return router.createUrlTree([path], { queryParams });
};
